import { useEffect } from "react";
import { siteContent } from "@/data/siteContent";

const updateMeta = (selector, content) => {
  const element = document.querySelector(selector);
  if (element) element.setAttribute("content", content);
};

export const PageMeta = ({ title, description, canonical }) => {
  useEffect(() => {
    document.title = title;
    updateMeta('meta[name="description"]', description);
    updateMeta('meta[property="og:title"]', title);
    updateMeta('meta[property="og:description"]', description);
    updateMeta('meta[property="og:url"]', canonical);
    updateMeta('meta[name="twitter:title"]', title);
    updateMeta('meta[name="twitter:description"]', description);
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) canonicalLink.setAttribute("href", canonical);
    updateMeta('meta[property="og:image"]', siteContent.brand.assets.fullLogo);
    updateMeta('meta[name="twitter:image"]', siteContent.brand.assets.fullLogo);
  }, [title, description, canonical]);

  return null;
};